var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DefaultLayout',[_c('CommonSection',{attrs:{"title":"События"}},[_c('PageSlug',[_c('h1',[_vm._v("Страница в разработке")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }